/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Api_Errors_Has_Active_EnrollmentsInputs */

const nl_import_api_errors_has_active_enrollments = /** @type {(inputs: Import_Api_Errors_Has_Active_EnrollmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze klas bevat nog leerlingen`)
};

/**

* @param {Import_Api_Errors_Has_Active_EnrollmentsInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const import_api_errors_has_active_enrollments = /** @type {((inputs?: Import_Api_Errors_Has_Active_EnrollmentsInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Api_Errors_Has_Active_EnrollmentsInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_import_api_errors_has_active_enrollments(inputs)
});
export { import_api_errors_has_active_enrollments as "import.api_errors.has_active_enrollments" }